export default {"src":"/_next/static/image/public/images/flags/flag_692.fbc43b564993d52ab8db988bd3222ce1.svg","height":16,"width":24};